import { useState } from "react"
import { FaClock, FaDownload, FaUpload } from "react-icons/fa"
import "./style/MidPanel.scss"

const MidPanel = () => {
  const [days, setDays] = useState<"7" | "30">("7")

  const chartData = [
    { date: "06-19", equity: 0 },
    { date: "06-20", equity: 0 },
    { date: "06-21", equity: 0 },
    { date: "06-22", equity: 0 },
    { date: "06-23", equity: 0 },
    { date: "06-24", equity: 0 },
    { date: "06-25", equity: 0 }
  ]

  const transactions = [
    { type: "Deposit", amount: 0, date: "2025-06-10 14:49:15" }
  ]

  return (
    <div className="mid-panel">
      <div className="chart-card">
        <div className="card-header">
          <span>Equity Trend</span>
          <div className="tabs">
            <button className={days === "7" ? "active" : ""} onClick={() => setDays("7")}>Last 7 days</button>
            <button className={days === "30" ? "active" : ""} onClick={() => setDays("30")}>Last 30 days</button>
          </div>
        </div>
        <div className="chart">
          {chartData.map((d, i) => (
            <div className="chart-point" key={i}>
              <span>{d.equity}</span>
              <small>{d.date}</small>
            </div>
          ))}
        </div>
      </div>

      <div className="transactions-card">
        <div className="card-header">
          <span>Recent Transactions</span>
          <span className="note">Lowest Withdrawal Fees Globally 🌍</span>
        </div>
        <ul className="transactions">
          {transactions.map((tx, i) => (
            <li key={i}>
              <div className="icon">{tx.type === "Withdraw" ? <FaUpload /> : <FaDownload />}</div>
              <div className="details">
                <div className="type">{tx.type}</div>
                <div className="date">{tx.date}</div>
              </div>
              <div className="amount">
                <span className={tx.amount >= 0 ? "plus" : "minus"}>
                  {tx.amount >= 0 ? "+" : "-"}{Math.abs(tx.amount).toLocaleString()} USDT
                </span>
                <div className="status">
                  {tx.type === "Withdraw" ? "Withdrawal Successful" : "Deposit successful"}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default MidPanel
